const service = function(
	$cordovaBadge,
	$cordovaPush,
	$filter,
	$ionicPopup,
	$rootScope,
	growl,
	Support,
	User,
) {
	"ngInject"

	this.init = function() {
		var push = $cordovaPush.init({
			ios: {
				alert: true,
				badge: true,
				sound: false,
				clearBadge: true
			}
		});

		push.on('registration', function(data) {
			if (!$rootScope.user.push_token) {
				User.setPushToken(data.registrationId).then(res => {
					console.log('registration succesfull');
				}).catch(err => {
					console.log('registration failed');
				});
			}
		});

		push.on('notification', (data) => {
			if (data.additionalData.type && data.additionalData.type === 'chat') {
				Support.setCount(data.count);
			}
			$cordovaBadge.badge.set(data.count);
		});

		$rootScope.$on('user:logout', function() {
			push.unregister(function() {
				console.log('unregister success');
			}, function() {
				console.log('unregister error');
			});
		});
	}
}

export default service;


// WEBPACK FOOTER //
// ./app/shared/services/push.service.js